<template>
  <div id="app" class="app">
    <component :is="layout" class="flex-1 flex flex-col">
      <router-view />
    </component>
    <FlashMessages />
  </div>
</template>

<script>
import DefaultLayout from "@/layouts/Default";

import FlashMessages from "@/components/FlashMessages.vue";

export default {
  name: "App",
  components: {
    FlashMessages,
  },
  computed: {
    layout() {
      return this.$route.meta.layout || DefaultLayout;
    },
  },
};
</script>

<style lang="scss">
@import "tailwindcss/base";
@import "tailwindcss/components";
@import "tailwindcss/utilities";

@import "~@/styles/variables.scss";
@import "~@/styles/base.scss";

.app {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* set the page full height */
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
</style>
